// Shared guard so multiple triggers (idle timeout, token expiry, a 401 response)
// can never race each other into conflicting redirects or leave a stale error
// flashing on screen while the browser is mid-navigation to the login page.

import { ROUTES } from '../constants/app.constants';
import StorageUtil from './storage';

let redirecting = false;

/** True once a forced logout redirect has been kicked off. */
export const isSessionRedirecting = () => redirecting;

/**
 * Clears auth and hard-navigates to the login page with the given reason.
 * Only the first caller wins — later calls (from a different trigger firing
 * moments later) are no-ops, so the user always sees a single, consistent
 * reason instead of one message getting clobbered by another mid-navigation.
 */
export const forceLogoutRedirect = (reason) => {
  if (redirecting) return;
  redirecting = true;
  StorageUtil.clearAuth();
  window.location.replace(`${ROUTES.LOGIN}?reason=${reason}`);
};
